import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import WTRClientTable from "./WTRClientTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
//import { WeeklyTradesReportFilter } from "./WeeklyTradesReportFilter";
import {
  DownloadButtonClient,
  DownloadExcelButtonClient,
} from "./DownloadButton";
import { weeklyTradesReportLocation } from "./Locations";
import { RouteComponentProps } from "react-router-dom";
import { useCurrentTradesReportFilter } from "../../../data/reports/weeklyTrade/hooks/useTradesReportFilter";

export interface WTRClientPageInfo {
  year: string;
  week: string;
}

export interface WTRClientPageProps
  extends RouteComponentProps<WTRClientPageInfo> {
  userAccessRights: AccessRights;
}

const WTRClientPage: React.FunctionComponent<WTRClientPageProps> = (props) => {
  const pageStyles = usePageStyles();

  // ovde su parametri za izvestaj
  // zbog toga stho se uzimaju iz URL-a moraju biti tipa string, ali ih konvertujem u number zbog toga sto to trazi API
  // dalje ih treba proslediti u odgovarajuci hook da bi se sacuvali u filteru u redux store-u
  const yearNumber = Number(props.match.params.year);
  const weekNumber = Number(props.match.params.week);
  console.log("Report params:", yearNumber, weekNumber);

  const [
    filter,
    setReportDate,
    setReportWeek,
    setReporthYear,
  ] = useCurrentTradesReportFilter();

  React.useEffect(() => setReportWeek(weekNumber), [weekNumber]);
  React.useEffect(() => setReporthYear(yearNumber), [yearNumber]);

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={
                <PageTitle
                  title="wTReportClientTitle"
                  backLocation={weeklyTradesReportLocation}
                />
              }
              action={<WeekActions />}
            />
            <Divider />
            <CardContent>
              <WTRClientTable userAccessRights={props.userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const WeekActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <DownloadButtonClient />
    </Grid>
    <Grid item>
      <DownloadExcelButtonClient />
    </Grid>
  </Grid>
);

export default WTRClientPage;
